webpackJsonp([35783957827783],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(153);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'hero-main is-fullheight' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-head' },
	        _react2.default.createElement(
	          'header',
	          { className: 'navbar' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'navbar-brand' },
	              _react2.default.createElement(
	                'figure',
	                { className: 'image', style: { padding: "10px 20px" } },
	                _react2.default.createElement('img', { src: '/img/alienduo-logo.svg', alt: 'Alien Duo' })
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'navbar-burger burger', 'data-target': 'navbarMenuHeroC' },
	                _react2.default.createElement('span', null),
	                _react2.default.createElement('span', null),
	                _react2.default.createElement('span', null)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'navbarMenuHeroC', className: 'navbar-menu' },
	              _react2.default.createElement(
	                'div',
	                { className: 'navbar-end' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'buttons' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'button is-outlined is-dark', href: 'https://twitter.com/alienduo' },
	                    'Twitter'
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'button is-outlined is-dark', href: 'https://patreon.com/alienduo' },
	                    'Patreon'
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'button is-outlined is-dark', href: 'mailto:contact@alienduo.com' },
	                    'Contact'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container has-text-centered' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'subtitle' },
	            'The Magnificent'
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'title', style: { color: "yellow", fontFamily: "Bangers", fontSize: "120pt", textShadow: "-5px 0 black, 0 10px red, 10px 0 black, 0 -10px black" } },
	            'Alien ',
	            _react2.default.createElement(
	              'span',
	              { style: { color: "blue" } },
	              'Duo'
	            )
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'title is-white', style: { fontSize: "32pt", color: "white", textShadow: "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black" } },
	            'The first code+creative studio* created by ',
	            _react2.default.createElement(
	              'b',
	              null,
	              'aliens'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'subtitle' },
	            '* Or "startup", but not a boring one :-P'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section has-background-black has-text-white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tile is-ancestor' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-9 is-vertical is-parent' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child' },
	              _react2.default.createElement(
	                'div',
	                { className: 'content has-text-white is-large' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'has-text-warning', style: { fontFamily: "Bangers" } },
	                  'Hello, Humans! \uD83D\uDC4B'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Let us introduce ourselves. We\'re a couple of ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'has-text-warning' },
	                    'aliens'
	                  ),
	                  ' \uD83D\uDC7D\uD83D\uDC7D. We were space-time traveling engineers on our home planet.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child' },
	              _react2.default.createElement(
	                'figure',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: '/img/comic000-001.jpg' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-vertical is-parent' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'In other words, We spent our days teleporting stuff . . .'
	              ),
	              _react2.default.createElement(
	                'figure',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: '/img/comic000-002.jpg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child' },
	              _react2.default.createElement(
	                'p',
	                null,
	                '. . . from one place \uD83C\uDF4F . . .'
	              ),
	              _react2.default.createElement(
	                'figure',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: '/img/comic000-003.jpg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child' },
	              _react2.default.createElement(
	                'p',
	                null,
	                '. . . to somewhere else \uD83E\uDD14.'
	              ),
	              _react2.default.createElement(
	                'figure',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: '/img/comic000-004.jpg' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tile is-ancestor' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-parent is-vertical' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child is-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'content has-text-white is-large has-text-centered' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Everything was just fine but . . . due to a system malfunction \uD83D\uDE31 -- you humans call it a ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'has-text-warning' },
	                    'bug'
	                  ),
	                  '\uD83D\uDC1E, that\'s cute -- we ended up teleported to this beautiful planet \uD83C\uDF0E of yours.'
	                ),
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'title', style: { color: "red", fontFamily: "Bangers", fontSize: "100pt", textShadow: "-5px 0 white, 0 10px white, 10px 0 black, 0 -10px black" } },
	                  '*** System Failure ***'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child' },
	              _react2.default.createElement(
	                'figure',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: '/img/comic000-005.jpg' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tile is-ancestor' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-parent' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-parent is-vertical' },
	              _react2.default.createElement(
	                'div',
	                { className: 'tile is-child' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content has-text-white is-large' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Although we\'re used to have eternal sunsets \uD83C\uDF05 on our planet...'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tile is-child' },
	                _react2.default.createElement(
	                  'figure',
	                  { className: 'image' },
	                  _react2.default.createElement('img', { src: '/img/comic000-010.jpg' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-parent is-vertical' },
	              _react2.default.createElement(
	                'div',
	                { className: 'tile is-child' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content has-text-white is-large' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    '...We fell in ',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'has-text-red' },
	                      'love'
	                    ),
	                    ' \uD83D\uDC9A with Earth.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tile is-child' },
	                _react2.default.createElement(
	                  'figure',
	                  { className: 'image' },
	                  _react2.default.createElement('img', { src: '/img/comic000-011.jpg' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-parent is-vertical' },
	              _react2.default.createElement(
	                'div',
	                { className: 'tile is-child' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content has-text-white is-large' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Maybe because here you don\'t have to worry about sun flares ',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'has-text-warning' },
	                      'burning'
	                    ),
	                    ' \uD83D\uDD25 your home overnight. A downside of ',
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'https://news.ycombinator.com/item?id=17124850' },
	                      'planets tidally locked'
	                    ),
	                    ' to their stars \uD83D\uDE41.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tile is-child' },
	                _react2.default.createElement(
	                  'figure',
	                  { className: 'image' },
	                  _react2.default.createElement('img', { src: '/img/comic000-009.jpg' })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'has-background-black has-text-white has-text-centered' },
	      _react2.default.createElement(
	        'div',
	        { className: 'tile is-ancestor' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tile is-parent' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-child' },
	            _react2.default.createElement(
	              'figure',
	              { className: 'image' },
	              _react2.default.createElement('img', { src: '/img/comic000-007.jpg' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-child', style: { padding: "30px" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'content is-large' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'So We decided to stay here with you gals and guys \uD83C\uDF89 at least for a while! ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Oh, and there\'s also this ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'has-text-info' },
	                  'small detail'
	                ),
	                ': current human science doesn\'t support teleportation yet \uD83E\uDD14, so we just can\'t go back for now.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                ' No problem though, we\'r not in a hurry.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-child' },
	            _react2.default.createElement(
	              'figure',
	              { className: 'image' },
	              _react2.default.createElement('img', { src: '/img/comic000-006.jpg' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section has-background-black has-text-white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tile is-ancestor' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-parent' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child' },
	              _react2.default.createElement(
	                'div',
	                { className: 'content is-large' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'But, you know, we also need to pay the bills \uD83D\uDE40.'
	                ),
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'title', style: { color: "red", fontFamily: "Bangers", fontSize: "100pt", textShadow: "-5px 0 white, 0 10px white, 10px 0 black, 0 -10px black" } },
	                  'Oh Noooo...'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child is-5' },
	              _react2.default.createElement(
	                'figure',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: '/img/comic000-008.jpg' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tile is-ancestor' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tile is-parent' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child' },
	              _react2.default.createElement(
	                'figure',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: '/img/comic000-012.jpg' })
	              ),
	              _react2.default.createElement(
	                'figure',
	                { className: 'image' },
	                _react2.default.createElement('img', { src: '/img/comic000-013.jpg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tile is-child', style: { padding: "30px" } },
	              _react2.default.createElement(
	                'div',
	                { className: 'content is-large' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Good news is: as soon as we got here we discovered that computer code \uD83D\uDCBB -- especially those written in Lisp \uD83D\uDE0B -- is the closest thing to the technology we are familiar with on our planet!'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Which means we can code \uD83D\uDCBB\uD83D\uDC12, give back to humans to thanks for the hospitability \uD83D\uDE4F and get paid for that \uD83D\uDCB8!'
	                ),
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'title', style: { color: "yellow", fontFamily: "Bangers", fontSize: "100pt", textShadow: "-5px 0 red, 0 10px red, 10px 0 black, 0 -10px black" } },
	                  'Let\'s hack!'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content is-large' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'So fast forward to today, we\'re bootstrapping \uD83D\uDC62 our own ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'has-text-warning' },
	                  'code+creative studio'
	                ),
	                ' \u270A! You can also call it our own startup \uD83E\uDD84.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We are crazy about hacking code -- and drinking ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'has-text-warning' },
	                  'beer'
	                ),
	                ' \uD83C\uDF7A, cheers! -- and creating experiments and apps using exciting technologies like',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tags' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'tag is-primary is-large' },
	                    '\uD83E\uDD16 Artificial Intelligence'
	                  ),
	                  ',',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'tag is-info is-large' },
	                    '\uD83C\uDF10 Web'
	                  ),
	                  ',',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'tag is-danger is-large' },
	                    '\uD83C\uDFA8 Generative Art'
	                  ),
	                  ' and',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'tag is-warning is-large' },
	                    '\uD83C\uDFB5 Music'
	                  ),
	                  '.'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We are going to share every step on this journey of running our studio with you, just follow us on ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://twitter.com/alienduo' },
	                  'Twitter \uD83D\uDC26'
	                ),
	                ' and feel free to interact with us there. We came in peace \u270C\uFE0F.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'figure',
	              { className: 'image is-2by3' },
	              _react2.default.createElement('img', { src: '/img/alien-coding.jpg' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero-changelog is-fullheight' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container has-text-centered' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title', style: { color: "yellow", fontFamily: "Bangers", fontSize: "120pt", textShadow: "-5px 0 black, 0 10px red, 10px 0 black, 0 -10px black" } },
	            'Support us!'
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'title is-white', style: { fontSize: "32pt", color: "white", textShadow: "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black" } },
	            _react2.default.createElement(
	              'p',
	              null,
	              'If you like what we\'re doing here, please support us on ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://patreon.com/alienduo' },
	                'Patreon \uD83D\uDE80'
	              ),
	              '! We have many, many cool ideas that we want to implement and your support will make them become true! \uD83D\uDC7D\uD83D\uDC7D\u2764\uFE0F'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'footer',
	      { className: 'footer has-text-white has-background-black' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content has-text-centered' },
	              _react2.default.createElement('img', { src: '/img/alienduo-logo.svg', style: { filter: "invert(100%)" }, height: '50px', alt: 'Alien Duo' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-two-thirds' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'The magnificent ',
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'has-text-warning' },
	                  'Alien Duo'
	                ),
	                ' is a meta-mix of software engineering and creative/art/design studio/startup. We\'re openly documenting the process in the form of a constantly updated Webcomics and Social Network presence.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'We create webapps, prototypes, demos, games, stories, art and music to solve humans problems and express our own ideas.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'We know that ',
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'has-text-warning' },
	                  'you want to believe'
	                ),
	                ', so believe on us, we\'re real aliens running a company.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'div',
	              { className: 'menu buttons' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'menu-list' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://twitter.com/alienduo', className: 'button is-warning is-outlined' },
	                    'Twitter'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://patreon.com/alienduo', className: 'button is-warning is-outlined' },
	                    'Patreon'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:contact@alienduo.com', className: 'button is-warning is-outlined' },
	                    'Contact'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-acd62cb83b9aae050467.js